import { FaCirclePlus } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import Icon from "../common/Icon";
import "./homePartial.css";

function MealSwiper({ slides }) {
  const filteredSlides = slides.sort((a, b) => a.sortOrder - b.sortOrder);
  const navigate = useNavigate();

  function isSnack(str) {
    if (!str) return false;
    const snacks = [
      "snack",
      "snacks",
      "afternoon snack",
      "afternoon snacks",
      "afternoon-snacks",
      "afternoon-snack",
      "evening snack",
      "evening-snack",
    ];
    return snacks.some((s) => s.toLowerCase() === str.toLowerCase().trim());
  }

    function isLunch(str) {
    if (!str) return false;
    const snacks = [
      "lunch",
      "lunch box",
    ];
    return snacks.some((s) => s.toLowerCase() === str.toLowerCase().trim());
  }

  return (
    <div className="relative w-full bg-green text-white 2xl:p-12 lg:p-8 p-12 h-[470px] overflow-hidden">
      <h2 className="text-32pt">Explore our</h2>
      <h2 className="text-48pt leading-none">Meals</h2>

      {/* FIXED PAGINATION AREA (450px height inside parent) */}
      <div
        className="
          absolute 
          bottom-[30px]
          2.5xl:bottom-[30px] 
          inset-x-12 
          lg:inset-x-8 
          2xl:inset-x-12 
          cursor-pointer
          pointer-events-auto z-[50]
        "
      >
        <div id="meal-pagination" className="flex items-end h-[20px] "></div>
      </div>

      <div className="relative w-full h-full">
        {/* INNER SWIPER ONLY — PARENT STAYS FIXED */}
        <Swiper
          modules={[Pagination]}
          pagination={{
            el: "#meal-pagination",
            clickable: true,
          }}
          loop={filteredSlides.length > 2}
          className="overflow-visible meal-swiper min-h-[300px]"
        >
          {filteredSlides.map((slide, index) => (
            <SwiperSlide key={index}>
              {/* ONLY THIS PART SLIDES NOW */}
              <div
                className="h-full w-full flex bg-green"
              >
                <div className="items-center relative w-full 1xl:translate-y-[10px] 2.5xl:-translate-y-3">
                  {/* Left Text + Icon Block */}
                  <div className="flex flex-col items-start justify-center gap-0 relative z-10 w-full">
                    <div className="w-[95%] flex flex-[1] items-start mt-0 gap-0 relative xl:translate-y-10 2xl:translate-y-3">
                      {/* Rotated Box */}
                      <Icon
                        icon="mealSectionBg"
                        
                        className="text-secondary w-full"
                      />

                      {/* Title inside rotated box */}
                      <div
                        className="absolute flex items-center justify-center text-center px-2"
                        style={{
                          top: "57%",
                          left: "10%",
                          transform: "translateY(-50%)",
                          width: "25%",
                        }}
                      >
                        <p className="break-words leading-tight 2xl:text-2xl lg:text-base text-lg text-quaternary">
                          {isSnack(slide.title) ? "Snacks" : isLunch(slide.title) ? "Lunch Box" : slide.title}
                        </p>
                      </div>

                      {/* Plate BG Image */}
                      {slide.image && (
                        <img
                          src={require("../../assets/images/plate.png")}
                          onError={(e) => {
                            const target = e.currentTarget;
                            target.onerror = null;
                            target.src = require("../../assets/images/link.png");
                            target.classList.remove(
                              "-right-[68px]",
                              "2xl:-right-6",
                              "2.5xl:-right-7",
                              "-top-1"
                            );
                            target.classList.add("-right-2", "top-2");
                          }}
                          className="absolute xl:w-[100%] xl:h-[108%] object-contain  -top-2 -right-[68px] 2xl:-right-[3.1rem] 2.5xl:-right-11 2xl:max-w-[280px] 2.5xl:max-w-[350px]"
                          alt={slide.title}
                        />
                      )}

                      {/* Actual Meal Image */}
                      {slide.image && (
                        <img
                          src={
                            slide.image
                              ? `${process.env.REACT_APP_BACKEND_URL}public/${slide.image}`
                              : require("../../assets/images/meal1.png")
                          }
                          onError={(e) => {
                            const target = e.currentTarget;
                            target.onerror = null;
                            target.src = require("../../assets/images/link.png");
                            target.classList.remove(
                              "-right-[68px]",
                              "2xl:-right-6",
                              "2.5xl:-right-7",
                              "-top-1"
                            );
                            target.classList.add("-right-2", "top-2");
                          }}
                          className="absolute xl:w-[100%] xl:h-[100%] object-contain -top-0 -right-[68px] 2xl:-right-2 2.5xl:-right-1 2.5xl:top-4 2xl:max-w-[180px] 2.5xl:max-w-[240px] 2.5xl:max-h-[240px]  rounded-full"
                          alt={slide.title}
                        />
                      )}

                      {/* Plus Icon */}
                      <FaCirclePlus
                        onClick={() => navigate(`/meals/${slide.title}`)}
                        title="Click to view meal details"
                        size={54}
                        className="absolute z-20 text-4xl md:text-5xl lg:text-6xl text-gray hover:text-orange hover:bg-white bg-secondary rounded-full cursor-pointer"
                        style={{
                          left: "36%",
                          bottom: "23%",
                          transform: "translate(25%, 50%)",
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}

export default MealSwiper;
